var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNilIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5C12.1365 15.5 15.5 12.1365 15.5 8C15.5 3.86346 12.1365 0.5 8 0.5C3.86346 0.5 0.5 3.86346 0.5 8C0.5 12.1365 3.86346 15.5 8 15.5ZM14.3462 8C14.3462 11.5019 11.5019 14.3462 8 14.3462C6.45962 14.3462 5.04038 13.7923 3.94423 12.875L12.875 3.94423C13.7923 5.04038 14.3462 6.45962 14.3462 8ZM8 1.65385C9.54038 1.65385 10.9596 2.20769 12.0558 3.125L3.125 12.0558C2.20769 10.9596 1.65385 9.54038 1.65385 8C1.65385 4.49808 4.49808 1.65385 8 1.65385Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNilIcon);
export default __webpack_public_path__ + "static/media/nil-icon.0c3a53595538471e0d56b1974d3557eb.svg";
export { ForwardRef as ReactComponent };